import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import {configureApi, apiUrl, getQueryParam, executeQuery} from './searchCommon';
import {translation} from './translation'

import CategorySearchMeta from '../vue/productSearch/CategorySearchMeta'
import CategorySearchList from '../vue/productSearch/CategorySearchList'
import Pagination from '../vue/productSearch/Pagination'
import CategoryFilter from '../vue/productSearch/CategoryFilter'
import CategoryCards from '../vue/productSearch/CategoryCards'

const searchApiToken = window.productSearchGraphQLApiKey || '';

// Site search application
function getcategorySearchLandingData() {
  return {
    allCategories: [],
    currentParentCat: null,
    sectionType: [],
    searchApi: axios.create(configureApi(apiUrl, searchApiToken)),
    searchQuery: '',
    searchCategories: [],
    categoryParams: false,
    searchFilters: [],
    propertyTypes: [],
    searchResults: [],
    searchSorting: 'postdate desc',
    categoryCards: [],
    filtersOpen: false,
    pagination: {
      totalCount: 0,
      pages: [],
      hasNext: false,
      hasPrev: false,
      nextPageUrl: '',
      prevPageUrl: '',
      elementsPerPage: 102,
      currentPage: 1
    },
    isLoading: true,
    isReady: false,
    hasParams: false,
    customers: [],
    showAll: false
  };
}

var filterChangeTimer;

var productSearchApp = function() {

// What to search for
const searchSite = document.getElementById('productSearchApp').dataset.site;
const searchSelectedSite = document.getElementById('productSearchApp').dataset.selectedSite;
const searchSections = ['KiltaProducts'];
const searchEntries = ['kiltaProducts_kiltaProducts_Entry'];
const searchCustomers = JSON.parse(document.getElementById('productSearchApp').dataset.customers);
const customers = searchCustomers.map(customer => {
  return {title: customer.title, slug: customer.slug, id: customer.id, level: null}
});

let searchQueries = ''
_.each(searchEntries, (entryType) => {
  searchQueries = searchQueries + 
      `
      ... on ${entryType} {
        id
        title: kiltaMarketingName
        url
        postDate
        kiltaPropertyTypes {
          title
        }
        kiltaFoodTypes {
          slug
        }
        kiltaImage {
          url(width:600, position:"center")
          title
        }
        kiltaCustomer {
          ... on kiltaCustomers_kiltaCustomers_Entry {
            id
            title
            kiltaImage {
              url(width:600, position:"center")
              title
            }
          }
        }
      }
    `
});

// The query to search for entries in Craft
const searchQuery =
  `
  query searchQuery($needle: String, $limit: Int, $offset: Int, $orderBy: String, $site: [String], $relatedTo: [QueryArgument], $kiltaRetailProduct: Boolean, $sections: [String], $kiltaFoodTypes: [QueryArgument], $kiltaPropertyTypes: [QueryArgument], $kiltaCustomer: [QueryArgument])
    {
      entries(limit: $limit offset: $offset orderBy: $orderBy search: $needle site: $site relatedTo: $relatedTo section: $sections kiltaRetailProduct: $kiltaRetailProduct kiltaFoodTypes: $kiltaFoodTypes kiltaPropertyTypes: $kiltaPropertyTypes kiltaCustomer: $kiltaCustomer) {
        ${searchQueries}
      }
      entryCount(limit: $limit offset: $offset orderBy: $orderBy search: $needle site: $site relatedTo: $relatedTo section: $sections kiltaRetailProduct: $kiltaRetailProduct kiltaFoodTypes: $kiltaFoodTypes kiltaPropertyTypes: $kiltaPropertyTypes kiltaCustomer: $kiltaCustomer)
    }
  `;

  new Vue({
    el: document.getElementById('productSearchApp'),
    delimiters: ['<%', '%>'],
    // Here we can register any values or collections that hold data
    data: getcategorySearchLandingData(),
    components: {
      CategorySearchList,
      CategorySearchMeta,
      Pagination,
      CategoryFilter,
      CategoryCards
    },
    beforeCreate: function() {
    },
    
    created: function() {
      this.getCategories();
      this.customers = customers;
      this.allCustomers = customers;
      const searchParam = getQueryParam('q');
      const categoryIdParam = getQueryParam('cat-id');
      const pageParam = getQueryParam('page');
      const showAllParam = getQueryParam('show-all');

      if (!!showAllParam) {
        this.showAll = true;
        this.performSearch();
      }

      if (!!searchParam) {
        this.searchQuery = searchParam;
        this.hasParams = true;
      }
      if(!!categoryIdParam) {
        this.hasParams = true;
        this.categoryParams = true;
      }
      if(!!pageParam) {
        this.hasParams = true;
      }
      window.addEventListener('click', (e) => {
        const filtersModal = document.getElementById('filters');
        if (filtersModal && !e.target.closest('.filters') && !e.target.closest('.filters-toggle') && !e.target.closest('.show-all-button') && !e.target.closest('.category-item-more') && !e.target.closest('.show-more-filters')){
          this.filtersOpen = false;
        }
      })
    },
    mounted: function() {
      // Focus style
      const elements = document.querySelectorAll("a, button, input[type='button'], select");
      let mouseDown = false;

      for (let i = 0; i < elements.length; i++) {
        elements[i].addEventListener('mousedown', () => {
          mouseDown = true;
        });
        
        elements[i].addEventListener('mouseup', () => {
          mouseDown = false;
        });
        
        elements[i].addEventListener('focus', (event) => {
          if (mouseDown) {
            event.target.blur();
          }
        });
      }
      const pageParam = getQueryParam('page');

      if(!!pageParam) {
        this.pagination.currentPage = parseInt(pageParam);
      }
      if (!_.isEmpty(this.searchQuery)) {
        if (!this.categoryParams) {
          this.performSearch();
        }
      }
    },
    updated: function() {
      var button = document.querySelectorAll('.tooltip-container-vue');
      button.forEach(element => {
        if (!element.classList.contains('tooltip-action-set')) {
          element.classList.add('tooltip-action-set')
          $(element).hover(function () {
            var $this = $(this);
            $this.toggleClass('active');
          });

        }
      });

      // recipes swiper
      const swiperRecipes = new Swiper('.swiper-recipes', {
        // Optional parameters
        autoHeight: false,
        spaceBetween: 24,
        slidesPerView: 'auto',
        
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
      });

      // recipes swiper
      const swiperArticles = new Swiper('.swiper-articles', {
        // Optional parameters
        autoHeight: false,
        spaceBetween: 24,
        slidesPerView: 'auto',

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
      });

      // recipes swiper
      const swiperLiftups = new Swiper('.swiper-liftups', {
        // Optional parameters
        autoHeight: false,
        spaceBetween: 24,
        slidesPerView: 'auto',  

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
      });

      // large card swiper
      const swiper = new Swiper('.swiper-large-cards', {
        // Optional parameters
        spaceBetween: 24,
        slidesPerView: 'auto',
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
      });
      
      // recipes swiper
      const swiperProducts = new Swiper('.swiper-products', {
        // Optional parameters
        autoHeight: false,
        spaceBetween: 24,
        slidesPerView: 'auto',

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true
        },
      });

      const images = document.querySelectorAll('img.product-card__image');

      images.forEach(img => {
        img.onerror = function () {
          const category = img.getAttribute('data-category');

          let fallbackSrc = ''; // Default fallback image
          let fallbackSVG = ''; // Default fallback svg
          switch (category) {
            case 'maitotuotteet':
              fallbackSVG = `
                <svg fill="none" height="50" viewBox="0 0 50 50" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m40.68 26.71h-10v-6.05c-.0009-.0166-.0009-.0333 0-.05-.0099-.1081-.0404-.2134-.09-.31v-.05l-5-8v-4.24999c0-.21217-.0843-.41565-.2343-.56568s-.3535-.23432-.5657-.23432h-10.33c-.2121 0-.4156.08429-.5657.23432-.15.15003-.2343.35351-.2343.56568v4.24999l-4.99998 8v.05c-.05408.0948-.08493.201-.09.31-.00246.0166-.00246.0334 0 .05v21.34c0 .2122.08429.4157.23432.5657s.35351.2343.56568.2343h21.03998c.2122 0 .4157-.0843.5657-.2343s.2343-.3535.2343-.5657c-.0214-.3369.0264-.6746.1405-.9923.1142-.3178.2923-.6087.5233-.8549s.51-.4424.8198-.5765c.3098-.1342.6438-.2034.9814-.2034s.6716.0692.9814.2034c.3098.1341.5889.3303.8199.5765s.409.5371.5232.8549c.1142.3177.162.6554.1405.9923 0 .2122.0843.4157.2343.5657.1501.15.3535.2343.5657.2343h3.74c.2122 0 .4157-.0843.5657-.2343s.2343-.3535.2343-.5657v-14.5c0-.1046-.0207-.2081-.0611-.3046-.0403-.0965-.0994-.1841-.1738-.2576s-.1627-.1314-.2597-.1705c-.097-.0392-.2008-.0586-.3054-.0573zm-.8 14.47h-2.22c-.1427-.7416-.4899-1.4286-1.0025-1.9833-.5125-.5547-1.17-.955-1.898-1.1558-.7281-.2007-1.4978-.1939-2.2222.0198-.7244.2136-1.3747.6256-1.8773 1.1893-.3504.3797-.6222.8249-.8 1.31-.0809.2-.1412.4078-.18.62h-9.3v-12.88h19.5zm-10.81-14.47h-8.68v-5.23h8.68zm-19-5.23h8.67v19.7h-8.62zm9.93-1.6-4.09-6.58h8.38l4.13 6.58zm3.89-8.18h-8.63v-2.87999h8.67zm-9.43 2.3 3.69 5.88h-7.38zm12.06 17.67c-.6853.0046-1.3493.2384-1.8864.6641-.537.4257-.9162 1.0189-1.0771 1.685-.1609.6662-.0943 1.367.1892 1.9909s.7677 1.135 1.3753 1.4519c.6076.317 1.3038.4215 1.9777.2969s1.2867-.471 1.7409-.9842.7236-1.1636.7654-1.8476c.0417-.684-.1466-1.3624-.535-1.927-.2841-.413-.6651-.7502-1.1096-.9821-.4445-.2318-.939-.3513-1.4404-.3479zm0 4.54c-.2903-.002-.5735-.0899-.8139-.2526s-.4273-.393-.537-.6617c-.1098-.2688-.1374-.5641-.0796-.8486.0578-.2844.1986-.5454.4046-.75s.4679-.3436.7528-.3995.5799-.0263.848.0853c.268.1115.497.3.6581.5415.161.2415.247.5253.247.8156 0 .1939-.0383.3859-.1128.5649s-.1837.3415-.3213.4781c-.1375.1366-.3008.2447-.4803.318s-.3717.1103-.5656.109z" fill="#3b3b3b"/>
                </svg>`;
              break;
            case 'rasvat':
              fallbackSVG = `
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M34.94 30.6C34.94 33.6023 33.7474 36.4815 31.6245 38.6045C29.5016 40.7274 26.6223 41.92 23.62 41.92C20.6178 41.92 17.7385 40.7274 15.6156 38.6045C13.4927 36.4815 12.3 33.6023 12.3 30.6C12.3 25.6 15.67 20.9 18.64 16.76C20.79 13.76 22.82 10.95 22.82 8.88C22.82 8.66783 22.9043 8.46435 23.0544 8.31432C23.2044 8.16429 23.4079 8.08 23.62 8.08C23.8322 8.08 24.0357 8.16429 24.1857 8.31432C24.3358 8.46435 24.42 8.66783 24.42 8.88C24.42 10.73 26.05 13.18 27.72 15.53C27.8416 15.7043 27.8898 15.9194 27.8543 16.1289C27.8188 16.3384 27.7023 16.5256 27.53 16.65L27.41 16.7C27.2422 16.786 27.0491 16.809 26.8656 16.765C26.6822 16.721 26.5206 16.6128 26.41 16.46C25.352 15.0573 24.4185 13.565 23.62 12C22.5632 14.0139 21.3318 15.9312 19.94 17.73C17.11 21.67 13.94 26.14 13.94 30.64C13.94 33.2179 14.9641 35.6902 16.787 37.5131C18.6098 39.3359 21.0821 40.36 23.66 40.36C26.238 40.36 28.7103 39.3359 30.5331 37.5131C32.356 35.6902 33.3801 33.2179 33.3801 30.64C33.3818 30.4916 33.4248 30.3465 33.5043 30.2211C33.5838 30.0957 33.6966 29.9949 33.8301 29.93C33.9386 29.8743 34.0581 29.8436 34.18 29.84C34.3785 29.8497 34.5662 29.9329 34.7067 30.0734C34.8472 30.2138 34.9304 30.4016 34.94 30.6ZM34.6101 16.15C36 18 37.7001 20.36 37.7001 23.05C37.6961 24.3477 37.225 25.6006 36.373 26.5794C35.5209 27.5582 34.3448 28.1974 33.0601 28.38C32.8084 28.4186 32.5546 28.442 32.3 28.45C30.8679 28.45 29.4944 27.8811 28.4817 26.8684C27.469 25.8557 26.9 24.4822 26.9 23.05C26.9658 21.4662 27.4563 19.9292 28.32 18.6C28.8378 17.7552 29.3986 16.9374 30 16.15C30.6726 15.3971 31.1862 14.5162 31.51 13.56C31.51 13.3478 31.5943 13.1443 31.7444 12.9943C31.8944 12.8443 32.0979 12.76 32.3101 12.76C32.5222 12.76 32.7257 12.8443 32.8757 12.9943C33.0258 13.1443 33.1101 13.3478 33.1101 13.56C33.431 14.5153 33.9411 15.3962 34.6101 16.15ZM32.32 26.85C33.3244 26.8447 34.2858 26.442 34.9941 25.73C35.7025 25.0179 36.1001 24.0544 36.1 23.05C36.1 20.89 34.56 18.78 33.32 17.05C32.9401 16.53 32.59 16.05 32.32 15.6C32.03 16.05 31.68 16.53 31.32 17.05C30.5204 18.0778 29.8206 19.1794 29.23 20.34C28.8057 21.1681 28.57 22.08 28.5401 23.01C28.5401 24.0178 28.9404 24.9844 29.653 25.697C30.3657 26.4096 31.3322 26.81 32.34 26.81L32.32 26.85Z" fill="#3B3B3B"/>
                </svg>`;
              break;
            case 'valmisruoat':
              fallbackSVG = `
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M31.72 17.09C31.7393 16.2397 31.9551 15.4054 32.3507 14.6525C32.7463 13.8995 33.3107 13.2484 34 12.75C35 11.83 35.78 11.11 35.78 9.59C35.78 9.37783 35.8642 9.17434 36.0143 9.02431C36.1643 8.87429 36.3678 8.79 36.58 8.79C36.7921 8.79 36.9956 8.87429 37.1456 9.02431C37.2957 9.17434 37.38 9.37783 37.38 9.59C37.358 10.4394 37.1398 11.2723 36.7426 12.0235C36.3453 12.7746 35.7797 13.4237 35.09 13.92C34.09 14.84 33.31 15.56 33.31 17.09C33.31 17.3022 33.2257 17.5057 33.0756 17.6557C32.9256 17.8057 32.7221 17.89 32.51 17.89C32.2978 17.89 32.0943 17.8057 31.9443 17.6557C31.7942 17.5057 31.71 17.3022 31.71 17.09H31.72ZM43.04 25.09C43.04 25.3022 42.9557 25.5057 42.8056 25.6557C42.6556 25.8057 42.4521 25.89 42.24 25.89H40.19L37.19 37.7C37.1473 37.8745 37.0472 38.0295 36.9057 38.1402C36.7642 38.2508 36.5896 38.3106 36.41 38.31H32.65C32.4793 38.3084 32.3134 38.2536 32.1754 38.1532C32.0373 38.0528 31.9341 37.9119 31.88 37.75C31.8431 37.6002 31.757 37.467 31.6356 37.3718C31.5141 37.2766 31.3643 37.2249 31.21 37.2249C31.0557 37.2249 30.9058 37.2766 30.7843 37.3718C30.6629 37.467 30.5768 37.6002 30.54 37.75C30.4891 37.9119 30.388 38.0534 30.2514 38.1541C30.1147 38.2547 29.9497 38.3093 29.78 38.31H26.09C25.9203 38.3093 25.7552 38.2547 25.6186 38.1541C25.4819 38.0534 25.3809 37.9119 25.33 37.75C25.2788 37.6122 25.1867 37.4934 25.0661 37.4095C24.9454 37.3255 24.8019 37.2805 24.655 37.2805C24.508 37.2805 24.3645 37.3255 24.2439 37.4095C24.1232 37.4934 24.0311 37.6122 23.98 37.75C23.9291 37.9119 23.828 38.0534 23.6914 38.1541C23.5548 38.2547 23.3897 38.3093 23.22 38.31H19.53C19.3603 38.3093 19.1952 38.2547 19.0586 38.1541C18.9219 38.0534 18.8209 37.9119 18.77 37.75C18.7213 37.6112 18.6306 37.4909 18.5106 37.4058C18.3906 37.3207 18.2471 37.2749 18.1 37.2749C17.9528 37.2749 17.8093 37.3207 17.6893 37.4058C17.5693 37.4909 17.4787 37.6112 17.43 37.75C17.3759 37.9119 17.2726 38.0528 17.1346 38.1532C16.9965 38.2536 16.8306 38.3084 16.66 38.31H12.88C12.7003 38.3106 12.5257 38.2508 12.3842 38.1402C12.2428 38.0295 12.1426 37.8745 12.1 37.7L9.09996 25.89H7.75996C7.6549 25.89 7.55087 25.8693 7.45381 25.8291C7.35675 25.7889 7.26856 25.73 7.19428 25.6557C7.11999 25.5814 7.06106 25.4932 7.02086 25.3961C6.98065 25.2991 6.95996 25.1951 6.95996 25.09C6.95996 24.9849 6.98065 24.8809 7.02086 24.7839C7.06106 24.6868 7.11999 24.5986 7.19428 24.5243C7.26856 24.45 7.35675 24.3911 7.45381 24.3509C7.55087 24.3107 7.6549 24.29 7.75996 24.29H12.41C12.6629 23.1533 13.2965 22.1372 14.2058 21.4097C15.115 20.6823 16.2455 20.2873 17.41 20.29C17.9833 20.2897 18.5522 20.3913 19.09 20.59C19.6678 19.4667 20.5388 18.5207 21.6107 17.8523C22.6826 17.1839 23.9154 16.8179 25.1783 16.7933C26.4413 16.7687 27.6874 17.0864 28.7845 17.7125C29.8816 18.3387 30.7888 19.2501 31.41 20.35C31.9664 20.1027 32.5712 19.9831 33.18 20C34.2825 20.0026 35.339 20.4418 36.1186 21.2214C36.8982 22.0009 37.3373 23.0575 37.34 24.16C37.3502 24.2128 37.3502 24.2672 37.34 24.32H42.28C42.478 24.3399 42.6615 24.4329 42.7946 24.5808C42.9277 24.7287 43.001 24.921 43 25.12L43.04 25.09ZM35.81 36.74L38.54 25.92H10.77L13.5 36.74H16.16C16.3813 36.4323 16.6727 36.1817 17.01 36.0089C17.3473 35.836 17.7209 35.7459 18.1 35.7459C18.479 35.7459 18.8526 35.836 19.1899 36.0089C19.5272 36.1817 19.8186 36.4323 20.04 36.74H22.71C22.9324 36.4323 23.2247 36.1817 23.5628 36.0089C23.901 35.8361 24.2752 35.746 24.655 35.746C25.0347 35.746 25.409 35.8361 25.7471 36.0089C26.0852 36.1817 26.3775 36.4323 26.6 36.74H29.27C29.4913 36.4323 29.7827 36.1817 30.12 36.0089C30.4573 35.836 30.8309 35.7459 31.21 35.7459C31.589 35.7459 31.9626 35.836 32.2999 36.0089C32.6372 36.1817 32.9286 36.4323 33.15 36.74H35.81ZM35.81 24.32C35.8053 24.2835 35.8053 24.2465 35.81 24.21C35.8052 24.1937 35.8052 24.1763 35.81 24.16C35.81 23.481 35.5402 22.8299 35.0602 22.3498C34.5801 21.8697 33.9289 21.6 33.25 21.6C32.6605 21.6007 32.0903 21.8097 31.64 22.19C31.543 22.2677 31.4292 22.3217 31.3077 22.3478C31.1862 22.3739 31.0602 22.3713 30.9399 22.3403C30.8196 22.3092 30.7081 22.2505 30.6144 22.1689C30.5207 22.0873 30.4472 21.9849 30.4 21.87C30.0009 20.836 29.295 19.9488 28.377 19.3277C27.4591 18.7066 26.373 18.3813 25.2648 18.3954C24.1565 18.4096 23.0791 18.7625 22.1773 19.4069C21.2755 20.0512 20.5925 20.9561 20.22 22C20.1793 22.1071 20.1164 22.2044 20.0354 22.2854C19.9544 22.3664 19.8571 22.4294 19.75 22.47C19.641 22.5088 19.5251 22.5244 19.4097 22.5158C19.2943 22.5072 19.182 22.4746 19.08 22.42C18.5633 22.1339 17.9804 21.989 17.39 22C16.659 22.0014 15.9466 22.2304 15.3517 22.6551C14.7567 23.0798 14.3088 23.6791 14.07 24.37H35.77L35.81 24.32ZM32 6C31.7878 6 31.5843 6.08429 31.4343 6.23431C31.2842 6.38434 31.2 6.58783 31.2 6.8C31.2 8.33 30.41 9.05 29.42 9.96C28.7289 10.4573 28.1625 11.108 27.7652 11.861C27.3678 12.614 27.1504 13.4488 27.13 14.3C27.13 14.5122 27.2142 14.7157 27.3643 14.8657C27.5143 15.0157 27.7178 15.1 27.93 15.1C28.1421 15.1 28.3456 15.0157 28.4956 14.8657C28.6457 14.7157 28.73 14.5122 28.73 14.3C28.73 12.78 29.51 12.06 30.5 11.14C31.194 10.6449 31.7632 9.99487 32.1624 9.24156C32.5616 8.48825 32.7799 7.65232 32.8 6.8C32.8 6.58783 32.7157 6.38434 32.5656 6.23431C32.4156 6.08429 32.2121 6 32 6Z" fill="#3B3B3B"/>
                </svg>`;
              break;
            case 'viljavalmisteet':
              fallbackSVG = `
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M35.75 18.65C35.7196 18.4996 35.6455 18.3615 35.537 18.253C35.4285 18.1445 35.2904 18.0704 35.14 18.04C33.9517 17.7752 32.7207 17.7648 31.5281 18.0095C30.3354 18.2543 29.208 18.7486 28.22 19.46C29.422 17.5256 29.8106 15.1944 29.301 12.9747C28.7915 10.755 27.4253 8.82664 25.5 7.61001C25.372 7.52693 25.2226 7.48273 25.07 7.48273C24.9174 7.48273 24.768 7.52693 24.64 7.61001C23.6731 8.21978 22.8373 9.01599 22.1813 9.9522C21.5254 10.8884 21.0624 11.9459 20.8195 13.0629C20.5765 14.1799 20.5584 15.3341 20.7663 16.4582C20.9741 17.5823 21.4037 18.6537 22.03 19.61C21.0257 18.833 19.863 18.286 18.624 18.0078C17.3851 17.7296 16.1001 17.7269 14.86 18C14.7096 18.0304 14.5715 18.1045 14.463 18.213C14.3545 18.3215 14.2804 18.4596 14.25 18.61C13.9334 20.0318 13.9809 21.5105 14.3883 22.909C14.7956 24.3076 15.5495 25.5806 16.58 26.61C16.76 26.79 16.97 26.93 17.16 27.09C16.3888 27.0511 15.6158 27.1116 14.86 27.27C14.7112 27.3039 14.575 27.3791 14.4671 27.487C14.3591 27.595 14.2839 27.7312 14.25 27.88C13.9666 29.1472 13.9718 30.462 14.2653 31.7269C14.5587 32.9919 15.1328 34.1746 15.9452 35.1877C16.7575 36.2007 17.7873 37.0181 18.9583 37.5794C20.1293 38.1406 21.4115 38.4313 22.71 38.43C23.2336 38.4213 23.7555 38.3678 24.27 38.27V41.67C24.27 41.8822 24.3543 42.0857 24.5043 42.2357C24.6544 42.3857 24.8578 42.47 25.07 42.47C25.2822 42.47 25.4857 42.3857 25.6357 42.2357C25.7857 42.0857 25.87 41.8822 25.87 41.67V38.33C26.3383 38.4195 26.8133 38.4696 27.29 38.48C28.5886 38.4813 29.8708 38.1906 31.0417 37.6294C32.2127 37.0681 33.2425 36.2507 34.0548 35.2377C34.8672 34.2246 35.4413 33.0419 35.7348 31.7769C36.0282 30.512 36.0334 29.1972 35.75 27.93C35.7161 27.7812 35.6409 27.645 35.533 27.537C35.4251 27.4291 35.2888 27.3539 35.14 27.32C34.3842 27.1616 33.6112 27.1011 32.84 27.14C33.03 26.97 33.24 26.84 33.42 26.66C34.4522 25.6296 35.207 24.3549 35.6144 22.9544C36.0218 21.554 36.0684 20.0733 35.75 18.65ZM32.29 34.81C31.5125 35.5844 30.5661 36.168 29.525 36.515C28.484 36.862 27.3767 36.963 26.29 36.81C26.1367 35.7236 26.2379 34.6165 26.5857 33.576C26.9336 32.5355 27.5184 31.59 28.2942 30.8142C29.07 30.0384 30.0155 29.4535 31.056 29.1057C32.0965 28.7579 33.2037 28.6567 34.29 28.81C34.4461 29.8967 34.3467 31.0049 33.9995 32.0465C33.6523 33.088 33.067 34.0343 32.29 34.81ZM23.74 36.81C22.6533 36.9655 21.5452 36.8657 20.5037 36.5187C19.4622 36.1716 18.5158 35.5868 17.7395 34.8105C16.9632 34.0342 16.3784 33.0878 16.0313 32.0463C15.6843 31.0048 15.5845 29.8968 15.74 28.81C16.8264 28.6567 17.9335 28.7579 18.974 29.1057C20.0146 29.4535 20.96 30.0384 21.7358 30.8142C22.5116 31.59 23.0965 32.5355 23.4443 33.576C23.7921 34.6165 23.8933 35.7236 23.74 36.81ZM15.74 19.5C16.8264 19.3467 17.9335 19.4479 18.974 19.7957C20.0146 20.1435 20.96 20.7284 21.7358 21.5042C22.5116 22.28 23.0965 23.2255 23.4443 24.266C23.7921 25.3065 23.8933 26.4136 23.74 27.5C22.6529 27.6576 21.5439 27.5594 20.5014 27.2131C19.4589 26.8668 18.5116 26.282 17.7348 25.5052C16.958 24.7285 16.3732 23.7811 16.0269 22.7386C15.6806 21.6961 15.5824 20.5872 15.74 19.5ZM27.94 14.92C27.9404 16.022 27.6829 17.1087 27.188 18.0933C26.6931 19.0778 25.9746 19.9329 25.09 20.59C24.2066 19.932 23.4892 19.0767 22.9949 18.0923C22.5007 17.1078 22.2433 16.0215 22.2433 14.92C22.2433 13.8185 22.5007 12.7322 22.9949 11.7478C23.4892 10.7633 24.2066 9.90801 25.09 9.25001C25.9698 9.9103 26.6836 10.7665 27.1748 11.7507C27.666 12.7349 27.9212 13.82 27.92 14.92H27.94ZM27.15 29.65C26.6663 30.1336 26.2432 30.6743 25.89 31.26V29C26.3582 29.0922 26.8331 29.1457 27.31 29.16C27.45 29.16 27.58 29.16 27.71 29.16C27.5 29.32 27.31 29.48 27.13 29.65H27.15ZM22.73 29.2C23.248 29.1764 23.7632 29.1095 24.27 29V31.5C23.8892 30.8229 23.4182 30.2005 22.87 29.65C22.69 29.48 22.5 29.32 22.31 29.16C22.44 29.16 22.57 29.2 22.71 29.2H22.73ZM24.27 22V22.24C24.18 22.08 24.08 21.94 23.99 21.79L24.27 22ZM26.27 27.55C26.1167 26.4636 26.2179 25.3565 26.5657 24.316C26.9136 23.2755 27.4984 22.33 28.2742 21.5542C29.05 20.7784 29.9955 20.1935 31.036 19.8457C32.0765 19.4979 33.1837 19.3967 34.27 19.55C34.4277 20.6372 34.3294 21.7461 33.9831 22.7886C33.6368 23.8311 33.052 24.7785 32.2753 25.5552C31.4985 26.332 30.5512 26.9168 29.5086 27.2631C28.4661 27.6094 27.3572 27.7076 26.27 27.55Z" fill="#3B3B3B"/>
                </svg>`;
              break;
            case 'kala-ja-kalavalmisteet':
              fallbackSVG = `
                <svg fill="none" height="50" viewBox="0 0 50 50" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m47.11 19.7c-.17-.44-.62-1-1.81-1-1.7639.058-3.4835.5674-4.9944 1.4796-1.5109.9121-2.7627 2.1965-3.6356 3.7304-1.304-1.9373-2.939-3.6298-4.83-5 1.75-1.46 2.12-2.84 2-3.89-.26-2-2.58-3.73-5.76-4.18-2.006-.311-4.0589-.0608-5.9315.7228-1.8726.7837-3.4919 2.0702-4.6785 3.7172-3.0105.4167-5.8864 1.5141-8.4093 3.2088-2.52289 1.6946-4.62639 3.9419-6.15071 6.5712-.06919.1238-.10552.2632-.10552.405s.03633.2812.10552.405c1.75023 3.0315 4.26545 5.5506 7.29431 7.3054 3.0288 1.7548 6.4652 2.684 9.9657 2.6946 1.631-.0205 3.2533-.2422 4.83-.66 2.33 2.93 4.55 4 6.21 4 .3385.0051.6758-.0422 1-.14.6016-.1603 1.1294-.5236 1.4938-1.0284.3645-.5048.5433-1.1201.5062-1.7416-.05-1.23-.89-2.76-2.87-4 2.0991-1.4098 3.9084-3.2089 5.33-5.3.8742 1.532 2.1265 2.8144 3.6373 3.7248 1.5108.9103 3.2297 1.4182 4.9927 1.4752 1.19 0 1.64-.53 1.81-1 .57-1.48-1.75-4.05-3.57-5.76 1.82-1.69 4.14-4.26 3.57-5.74zm-9.48 5.77c.687-1.4756 1.7651-2.7349 3.1173-3.641 1.3521-.9061 2.9267-1.4246 4.5527-1.499h.3c-.11.71-1.81 2.76-3.78 4.53-.0821.0758-.1476.1679-.1924.2703-.0449.1023-.068.2129-.068.3247s.0231.2223.068.3247c.0448.1024.1103.1944.1924.2703 2.07 1.86 3.84 4 3.88 4.49-.1286.0436-.2647.0607-.4.05-1.6239-.0726-3.197-.588-4.5489-1.4905-1.352-.9025-2.4313-2.1576-3.1211-3.6295zm-5.87 12.12c-.89.27-2.78-.2-5.08-2.9 1.0593-.3633 2.0863-.8149 3.07-1.35 1.87.9 2.78 2.08 2.82 3.07.0259.2606-.0412.522-.1894.738-.1483.2159-.3681.3725-.6206.442zm-3-5.52-1.07.52c-.653.2908-1.3206.5478-2 .77-.27.08-.53.2-.8.27s-.56.1-.84.16c-1.2562.2905-2.5407.4415-3.83.45-3.1466 0-6.2407-.806-8.9874-2.3413-2.74659-1.5352-5.05415-3.7485-6.70261-6.4287 1.31267-2.1249 3.04352-3.9607 5.08746-5.3961 2.04395-1.4354 4.35825-2.4404 6.80255-2.9539.33-.07.65-.14 1-.19s.67-.09 1-.12c.5876-.0698 1.1783-.1099 1.77-.12 3.0477.0101 6.0447.78 8.72 2.24.28.15.53.32.8.48s.5.32.74.48c2.1666 1.4568 3.9973 3.3592 5.37 5.58-1.5391 2.4915-3.6511 4.5794-6.16 6.09-.32.17-.61.35-.91.51zm-.91-19.63c2.38.33 4.23 1.51 4.39 2.79.12.88-.52 1.83-1.79 2.76-3.0949-1.8851-6.6463-2.8879-10.27-2.9-.18 0-.35 0-.52 0 1.0622-1.0492 2.3552-1.8353 3.7756-2.2954 1.4204-.4602 2.9287-.5816 4.4044-.3546zm-16.44 10.42c-.2477-.002-.4903.0696-.6972.2058-.2068.1361-.3686.3306-.4648.5589-.0961.2282-.1223.4798-.0752.723.0471.2431.1654.4668.3398.6426s.3971.2958.6398.3449c.2428.049.4946.0249.7236-.0694s.4248-.2545.5626-.4603.2114-.4479.2114-.6955c0-.3298-.1303-.6462-.3626-.8804-.2322-.2341-.5476-.367-.8774-.3696zm5.35-2.52c.7142 1.6159 1.0831 3.3632 1.0831 5.13 0 1.7667-.3689 3.514-1.0831 5.13-.0647.1358-.1669.2502-.2944.3299-.1276.0798-.2752.1214-.4256.1201-.1213.0013-.2413-.0261-.35-.08-.1892-.0947-.3338-.2597-.403-.4596-.0691-.2-.0573-.4191.033-.6104.3228-.7869.551-1.6093.68-2.45.2427-1.3223.2427-2.6777 0-4-.1198-.8438-.3518-1.6677-.69-2.45-.0705-.1854-.0697-.3903.0024-.5751s.2102-.3362.3876-.4249c.1867-.0895.4005-.1042.5977-.0409.1971.0632.3625.1995.4623.3809z" fill="#3b3b3b"/>
                </svg>`;
              break;
            case 'liha':
              fallbackSVG = `
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M41.39 23.47C41.49 22.31 41.19 19.54 36.18 18.76C32.9064 18.1651 29.785 16.9206 27 15.1C23.22 12.88 20 10.97 14.07 13.58C12.5074 14.1891 11.1556 15.2394 10.1791 16.6029C9.20261 17.9665 8.64356 19.5845 8.57002 21.26C8.57002 21.73 8.57002 22.85 8.57002 23.9C8.57002 24.95 8.57002 25.66 8.57002 25.98C8.54925 27.3321 8.80459 28.6743 9.32043 29.9243C9.83626 31.1744 10.6017 32.306 11.57 33.25C14.32 36.11 18.57 37.68 23.57 37.68C33.33 37.68 41.06 32.68 41.45 28.19C41.45 27.68 41.45 26.64 41.45 25.55C41.38 24.66 41.36 23.81 41.39 23.47ZM39.8 28.05C39.51 31.32 33.03 36.05 23.51 36.05C18.99 36.05 15.16 34.65 12.71 32.11C11.3085 30.7046 10.4389 28.8558 10.25 26.88C10.6373 27.4581 11.0757 28.0003 11.56 28.5C14.31 31.35 18.56 32.92 23.56 32.92C30.89 32.92 37.08 30.1 39.87 26.79C39.82 27.35 39.82 27.81 39.8 28.05ZM14.74 15.05C16.1786 14.3492 17.7504 13.9639 19.35 13.92C21.85 13.92 23.81 15.07 26.21 16.48C29.1578 18.4066 32.4636 19.7194 35.93 20.34C37.45 20.57 39.93 21.28 39.8 23.34C39.51 26.61 33.03 31.34 23.51 31.34C18.99 31.34 15.16 29.95 12.71 27.41C11.8989 26.6168 11.2574 25.6671 10.8242 24.6185C10.391 23.57 10.1753 22.4444 10.19 21.31C10.2616 19.9382 10.7296 18.6167 11.5372 17.5056C12.3448 16.3945 13.4573 15.5415 14.74 15.05ZM18.38 24.67C18.9787 24.6683 19.5743 24.5842 20.15 24.42C20.8138 24.2663 21.4392 23.9786 21.9877 23.5745C22.5363 23.1703 22.9965 22.6584 23.34 22.07C23.5048 21.7532 23.6023 21.4059 23.6263 21.0496C23.6504 20.6934 23.6006 20.336 23.48 20C22.81 18.29 20.36 17.49 17.89 18.18C17.2262 18.3337 16.6009 18.6214 16.0523 19.0255C15.5038 19.4296 15.0436 19.9416 14.7 20.53C14.5273 20.8533 14.4262 21.21 14.4038 21.5758C14.3814 21.9417 14.4381 22.308 14.57 22.65C14.9351 23.3249 15.4916 23.8768 16.1695 24.2363C16.8474 24.5957 17.6165 24.7466 18.38 24.67ZM22 20.53C22.0487 20.6652 22.0676 20.8094 22.0556 20.9526C22.0435 21.0959 22.0007 21.2348 21.93 21.36C21.4267 22.1334 20.6406 22.679 19.74 22.88C17.97 23.37 16.39 22.82 16.08 22.02C16.0314 21.8847 16.0124 21.7406 16.0245 21.5974C16.0366 21.4541 16.0794 21.3152 16.15 21.19C16.6533 20.4166 17.4394 19.871 18.34 19.67C18.776 19.5462 19.2268 19.4823 19.68 19.48C20.1261 19.4221 20.5795 19.4897 20.9893 19.6752C21.3991 19.8606 21.7491 20.1567 22 20.53Z" fill="#3B3B3B"/>
                </svg>`;
              break;
            case 'lihavalmisteet':
              fallbackSVG = `
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M46.45 24.55C45.5083 24.5379 44.5777 24.7546 43.7382 25.1813C42.8987 25.608 42.1752 26.2321 41.63 27C40.9679 25.484 39.8699 24.1991 38.4757 23.3088C37.0814 22.4185 35.4538 21.9629 33.8 22H25.22C22.54 22 20.44 25.34 20.44 29.6C20.3683 31.7506 21.0196 33.8632 22.29 35.6H17.44C17.7674 35.0169 17.8906 34.3411 17.79 33.68L15.2 15.53C15.1457 15.178 15.0271 14.839 14.85 14.53H30.05C30.7532 14.5307 31.4339 14.7783 31.9731 15.2298C32.5123 15.6813 32.8757 16.3078 33 17L33.35 19.41C33.371 19.5469 33.4272 19.676 33.5131 19.7847C33.599 19.8934 33.7116 19.9779 33.84 20.03C33.9693 20.0848 34.1104 20.1054 34.25 20.09C34.4592 20.0602 34.6482 19.9489 34.7756 19.7802C34.903 19.6116 34.9585 19.3994 34.93 19.19L34.59 16.78C34.4301 15.6984 33.8885 14.7097 33.0632 13.9926C32.2379 13.2755 31.1833 12.8773 30.09 12.87H8.41999C7.6874 12.8859 6.98413 13.1608 6.43495 13.6459C5.88577 14.131 5.52618 14.795 5.41999 15.52L2.78999 33.6C2.72237 34.0362 2.75184 34.4819 2.87629 34.9054C3.00075 35.3289 3.21713 35.7197 3.50999 36.05C3.79786 36.3863 4.15525 36.6561 4.55752 36.8408C4.95978 37.0255 5.39734 37.1208 5.83999 37.12H33.84C35.4919 37.1538 37.1167 36.6967 38.5087 35.8067C39.9008 34.9166 40.9975 33.6336 41.66 32.12C42.2078 32.8862 42.9337 33.5078 43.7751 33.9311C44.6165 34.3544 45.5482 34.5668 46.49 34.55C46.5946 34.55 46.6981 34.5292 46.7946 34.4889C46.8911 34.4486 46.9787 34.3895 47.0522 34.3151C47.1257 34.2407 47.1836 34.1524 47.2227 34.0554C47.2619 33.9584 47.2813 33.8546 47.28 33.75V25.35C47.2815 25.242 47.2608 25.1348 47.2193 25.035C47.1777 24.9353 47.1161 24.8452 47.0383 24.7702C46.9605 24.6952 46.8682 24.637 46.767 24.5991C46.6658 24.5612 46.5579 24.5445 46.45 24.55ZM45.65 32.87C44.804 32.7835 44.0152 32.4028 43.4213 31.7942C42.8273 31.1856 42.4659 30.3878 42.4 29.54C42.4643 28.6926 42.8254 27.895 43.4199 27.2877C44.0144 26.6804 44.8041 26.3023 45.65 26.22V32.87ZM33.8 35.52H28.15C29.4168 33.7819 30.0646 31.6694 29.99 29.52C29.99 29.44 29.99 29.37 29.99 29.3C30.0291 27.225 29.3862 25.1944 28.16 23.52H33.8C37.52 23.52 40.55 26.21 40.55 29.52C40.55 32.83 37.52 35.52 33.8 35.52ZM22 29.52C22 26.27 23.46 23.52 25.18 23.52C26.9 23.52 28.35 26.27 28.35 29.52C28.35 32.77 26.9 35.52 25.18 35.52C23.49 35.51 22 32.77 22 29.52ZM13.62 15.75L16.21 33.82C16.2378 34.0302 16.221 34.244 16.1607 34.4473C16.1004 34.6506 15.9979 34.8389 15.86 35C15.7204 35.1599 15.5483 35.2881 15.3551 35.376C15.1619 35.464 14.9522 35.5097 14.74 35.51H8.73999C8.88742 35.3501 8.9787 35.1465 8.99999 34.93C8.98335 34.6871 8.8787 34.4587 8.70564 34.2875C8.53259 34.1162 8.30302 34.014 8.05999 34C7.8221 34.0184 7.59862 34.1212 7.42991 34.2899C7.2612 34.4586 7.15837 34.6821 7.13999 34.92C7.15535 35.1429 7.25132 35.3526 7.40999 35.51H5.83999C5.62775 35.5097 5.41803 35.464 5.22487 35.376C5.03172 35.2881 4.85958 35.1599 4.71999 35C4.62042 34.8738 4.54268 34.7319 4.48999 34.58C4.46268 34.5354 4.43926 34.4886 4.41999 34.44C4.37446 34.2325 4.37446 34.0175 4.41999 33.81L6.99999 15.75C7.05261 15.3975 7.22986 15.0755 7.49956 14.8425C7.76927 14.6095 8.11357 14.4809 8.46999 14.48H12.19C12.5395 14.4903 12.8742 14.6231 13.1356 14.8553C13.3971 15.0875 13.5685 15.4042 13.62 15.75ZM9.99999 19.19C10.0206 18.9539 10.1245 18.7328 10.293 18.5661C10.4615 18.3995 10.6837 18.2981 10.92 18.28C11.1462 18.3037 11.3556 18.4103 11.5078 18.5793C11.66 18.7482 11.7442 18.9676 11.7442 19.195C11.7442 19.4224 11.66 19.6418 11.5078 19.8107C11.3556 19.9797 11.1462 20.0863 10.92 20.11C10.6821 20.0916 10.4586 19.9888 10.2899 19.8201C10.1212 19.6514 10.0184 19.4279 9.99999 19.19ZM8.73999 24.08C8.98399 24.08 9.21799 24.1769 9.39053 24.3495C9.56306 24.522 9.65999 24.756 9.65999 25C9.65999 25.244 9.56306 25.478 9.39053 25.6505C9.21799 25.8231 8.98399 25.92 8.73999 25.92C8.49599 25.92 8.26198 25.8231 8.08945 25.6505C7.91692 25.478 7.81999 25.244 7.81999 25C7.81999 24.756 7.91692 24.522 8.08945 24.3495C8.26198 24.1769 8.49599 24.08 8.73999 24.08ZM12.18 30.08C12.3082 30.0666 12.4378 30.0802 12.5603 30.1201C12.6829 30.16 12.7957 30.2252 12.8915 30.3114C12.9873 30.3977 13.0639 30.5031 13.1163 30.6209C13.1687 30.7386 13.1958 30.8661 13.1958 30.995C13.1958 31.1239 13.1687 31.2513 13.1163 31.3691C13.0639 31.4869 12.9873 31.5923 12.8915 31.6786C12.7957 31.7648 12.6829 31.83 12.5603 31.8699C12.4378 31.9097 12.3082 31.9234 12.18 31.91C11.9538 31.8863 11.7444 31.7797 11.5922 31.6107C11.44 31.4418 11.3558 31.2224 11.3558 30.995C11.3558 30.7676 11.44 30.5482 11.5922 30.3793C11.7444 30.2103 11.9538 30.1037 12.18 30.08Z" fill="#3B3B3B"/>
                </svg>`;
              break;
            case 'kasvikset':
              fallbackSVG = `
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.79 31.41C11.9154 31.404 12.9932 30.9549 13.79 30.16L13.87 30.1C15.55 28.57 16.22 28.69 16.38 28.76C16.79 28.94 17.27 29.84 17.27 33.08V38.38C17.27 38.5922 17.3543 38.7957 17.5043 38.9457C17.6543 39.0957 17.8578 39.18 18.07 39.18H22.64C22.8521 39.18 23.0556 39.0957 23.2057 38.9457C23.3557 38.7957 23.44 38.5922 23.44 38.38C23.44 38.1678 23.3557 37.9643 23.2057 37.8143C23.0556 37.6643 22.8521 37.58 22.64 37.58H18.9V33.08C18.9 30.5 18.68 28.01 17.06 27.3C15.97 26.82 14.62 27.3 12.93 28.82L12.77 28.95C12.5146 29.2243 12.2048 29.4424 11.8605 29.5905C11.5162 29.7386 11.1448 29.8133 10.77 29.81C10.1438 29.8065 9.53761 29.5893 9.05159 29.1945C8.56557 28.7997 8.22885 28.2508 8.09709 27.6387C7.96533 27.0265 8.04643 26.3878 8.32697 25.8279C8.60752 25.2681 9.07072 24.8208 9.63997 24.56C9.78141 24.4988 9.90186 24.3975 9.98647 24.2687C10.0711 24.1399 10.1162 23.9891 10.1162 23.835C10.1162 23.6809 10.0711 23.5301 9.98647 23.4013C9.90186 23.2725 9.78141 23.1712 9.63997 23.11C9.07072 22.8492 8.60752 22.4019 8.32697 21.842C8.04643 21.2822 7.96533 20.6434 8.09709 20.0313C8.22885 19.4191 8.56557 18.8703 9.05159 18.4755C9.53761 18.0807 10.1438 17.8635 10.77 17.86C11.2173 17.8683 11.6548 17.9923 12.04 18.22C12.1817 18.2927 12.3417 18.322 12.5 18.3042C12.6584 18.2864 12.8079 18.2223 12.93 18.12C13.0532 18.0184 13.1423 17.8815 13.1852 17.7277C13.2281 17.5739 13.2228 17.4107 13.17 17.26C13.0682 16.9871 13.0075 16.7007 12.99 16.41C12.9935 15.7838 13.2106 15.1776 13.6055 14.6916C14.0003 14.2056 14.5491 13.8689 15.1613 13.7371C15.7734 13.6054 16.4122 13.6865 16.972 13.967C17.5318 14.2475 17.9791 14.7107 18.24 15.28C18.3112 15.4419 18.4346 15.5751 18.5905 15.6585C18.7464 15.7419 18.9258 15.7706 19.1 15.74C19.2737 15.7106 19.433 15.6254 19.5539 15.4973C19.6749 15.3691 19.7507 15.2051 19.77 15.03C19.8225 14.3508 20.1281 13.716 20.6262 13.2512C21.1243 12.7864 21.7787 12.5255 22.46 12.52C22.9111 12.5167 23.356 12.6252 23.7549 12.8359C24.1538 13.0466 24.4943 13.3528 24.746 13.7273C24.9976 14.1017 25.1525 14.5327 25.1968 14.9817C25.2411 15.4306 25.1735 15.8836 25 16.3C24.9364 16.4647 24.9284 16.6457 24.9771 16.8153C25.0258 16.985 25.1287 17.1341 25.27 17.24C25.4119 17.3536 25.5882 17.4155 25.77 17.4155C25.9517 17.4155 26.1281 17.3536 26.27 17.24C26.6699 16.9155 27.1534 16.7108 27.6647 16.6494C28.1761 16.5881 28.6943 16.6726 29.1596 16.8932C29.6249 17.1139 30.0184 17.4616 30.2945 17.8964C30.5706 18.3311 30.7181 18.835 30.72 19.35C30.7192 19.5876 30.6821 19.8236 30.61 20.05H30.5C28.12 19.86 24.87 19.6 22.75 21.56C21.41 22.8 20.75 24.76 20.75 27.39C20.7423 29.6569 21.4184 31.8733 22.69 33.75C24.0521 35.7836 26.032 37.3253 28.3375 38.1475C30.6429 38.9696 33.1516 39.0286 35.4932 38.3157C37.8347 37.6028 39.8849 36.1559 41.3411 34.1885C42.7973 32.2211 43.5822 29.8376 43.58 27.39C43.58 24.76 42.9 22.8 41.58 21.56C40.4735 20.6151 39.0835 20.0661 37.63 20C38.1233 19.6739 38.5823 19.2987 39 18.88C39.9444 17.9256 40.6745 16.7808 41.1418 15.5221C41.6091 14.2633 41.8028 12.9195 41.71 11.58C41.6984 11.3866 41.617 11.2039 41.4809 11.066C41.3448 10.928 41.1632 10.8442 40.97 10.83C39.6301 10.7417 38.2866 10.9385 37.0283 11.4073C35.77 11.8762 34.6254 12.6064 33.67 13.55C32.7389 14.4827 32.0193 15.6047 31.56 16.84C31.1581 16.2698 30.6248 15.8048 30.0051 15.4845C29.3853 15.1642 28.6976 14.998 28 15C27.6171 15.0023 27.2366 15.0595 26.87 15.17C26.8337 14.0398 26.3597 12.9679 25.5481 12.1806C24.7365 11.3932 23.6507 10.952 22.52 10.95C21.7395 10.9499 20.9738 11.1631 20.3058 11.5668C19.6378 11.9704 19.0929 12.549 18.73 13.24C17.9379 12.4999 16.894 12.0888 15.81 12.09C14.6732 12.0922 13.582 12.5372 12.768 13.3307C11.954 14.1242 11.4812 15.2036 11.45 16.34C10.8309 16.2464 10.1989 16.2876 9.59723 16.4607C8.99554 16.6338 8.4383 16.9348 7.9636 17.3431C7.4889 17.7513 7.10792 18.2572 6.84669 18.8262C6.58546 19.3952 6.45014 20.0139 6.44997 20.64C6.44995 21.2488 6.5792 21.8506 6.82916 22.4057C7.07913 22.9608 7.44411 23.4565 7.89997 23.86C7.2425 24.4459 6.77885 25.218 6.57059 26.0738C6.36234 26.9295 6.41935 27.8283 6.73404 28.6508C7.04873 29.4734 7.60622 30.1807 8.33245 30.6789C9.05868 31.1771 9.91929 31.4425 10.8 31.44L10.79 31.41ZM40.1 12.41C40.0665 14.4125 39.2561 16.3237 37.8399 17.7399C36.4237 19.1561 34.5125 19.9665 32.51 20C32.5434 17.9974 33.3538 16.0863 34.77 14.6701C36.1862 13.2538 38.0974 12.4434 40.1 12.41ZM40.45 22.7C41.45 23.63 41.96 25.2 41.96 27.36C41.9645 29.5583 41.229 31.6942 39.872 33.4236C38.5149 35.1531 36.6153 36.3755 34.479 36.8939C32.3427 37.4124 30.0941 37.1968 28.0952 36.2819C26.0964 35.3669 24.4637 33.8058 23.46 31.85C22.9012 30.7563 22.5616 29.564 22.46 28.34C22.4055 28.0091 22.3721 27.6751 22.36 27.34C22.36 25.18 22.87 23.61 23.87 22.68C25.0539 21.7905 26.5249 21.3702 28 21.5C28.49 21.5 29 21.5 29.44 21.57L30.37 21.62H30.58L31.58 21.67C32.364 21.6899 33.1485 21.6666 33.93 21.6C36.11 21.45 38.85 21.23 40.45 22.71V22.7Z" fill="#3B3B3B"/>
                </svg>`;
              break;
            case 'mausteet-ja-maustekastikkeet':
              fallbackSVG = `
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.79 31.41C11.9154 31.404 12.9932 30.9549 13.79 30.16L13.87 30.1C15.55 28.57 16.22 28.69 16.38 28.76C16.79 28.94 17.27 29.84 17.27 33.08V38.38C17.27 38.5922 17.3543 38.7957 17.5043 38.9457C17.6543 39.0957 17.8578 39.18 18.07 39.18H22.64C22.8521 39.18 23.0556 39.0957 23.2057 38.9457C23.3557 38.7957 23.44 38.5922 23.44 38.38C23.44 38.1678 23.3557 37.9643 23.2057 37.8143C23.0556 37.6643 22.8521 37.58 22.64 37.58H18.9V33.08C18.9 30.5 18.68 28.01 17.06 27.3C15.97 26.82 14.62 27.3 12.93 28.82L12.77 28.95C12.5146 29.2243 12.2048 29.4424 11.8605 29.5905C11.5162 29.7386 11.1448 29.8133 10.77 29.81C10.1438 29.8065 9.53761 29.5893 9.05159 29.1945C8.56557 28.7997 8.22885 28.2508 8.09709 27.6387C7.96533 27.0265 8.04643 26.3878 8.32697 25.8279C8.60752 25.2681 9.07072 24.8208 9.63997 24.56C9.78141 24.4988 9.90186 24.3975 9.98647 24.2687C10.0711 24.1399 10.1162 23.9891 10.1162 23.835C10.1162 23.6809 10.0711 23.5301 9.98647 23.4013C9.90186 23.2725 9.78141 23.1712 9.63997 23.11C9.07072 22.8492 8.60752 22.4019 8.32697 21.842C8.04643 21.2822 7.96533 20.6434 8.09709 20.0313C8.22885 19.4191 8.56557 18.8703 9.05159 18.4755C9.53761 18.0807 10.1438 17.8635 10.77 17.86C11.2173 17.8683 11.6548 17.9923 12.04 18.22C12.1817 18.2927 12.3417 18.322 12.5 18.3042C12.6584 18.2864 12.8079 18.2223 12.93 18.12C13.0532 18.0184 13.1423 17.8815 13.1852 17.7277C13.2281 17.5739 13.2228 17.4107 13.17 17.26C13.0682 16.9871 13.0075 16.7007 12.99 16.41C12.9935 15.7838 13.2106 15.1776 13.6055 14.6916C14.0003 14.2056 14.5491 13.8689 15.1613 13.7371C15.7734 13.6054 16.4122 13.6865 16.972 13.967C17.5318 14.2475 17.9791 14.7107 18.24 15.28C18.3112 15.4419 18.4346 15.5751 18.5905 15.6585C18.7464 15.7419 18.9258 15.7706 19.1 15.74C19.2737 15.7106 19.433 15.6254 19.5539 15.4973C19.6749 15.3691 19.7507 15.2051 19.77 15.03C19.8225 14.3508 20.1281 13.716 20.6262 13.2512C21.1243 12.7864 21.7787 12.5255 22.46 12.52C22.9111 12.5167 23.356 12.6252 23.7549 12.8359C24.1538 13.0466 24.4943 13.3528 24.746 13.7273C24.9976 14.1017 25.1525 14.5327 25.1968 14.9817C25.2411 15.4306 25.1735 15.8836 25 16.3C24.9364 16.4647 24.9284 16.6457 24.9771 16.8153C25.0258 16.985 25.1287 17.1341 25.27 17.24C25.4119 17.3536 25.5882 17.4155 25.77 17.4155C25.9517 17.4155 26.1281 17.3536 26.27 17.24C26.6699 16.9155 27.1534 16.7108 27.6647 16.6494C28.1761 16.5881 28.6943 16.6726 29.1596 16.8932C29.6249 17.1139 30.0184 17.4616 30.2945 17.8964C30.5706 18.3311 30.7181 18.835 30.72 19.35C30.7192 19.5876 30.6821 19.8236 30.61 20.05H30.5C28.12 19.86 24.87 19.6 22.75 21.56C21.41 22.8 20.75 24.76 20.75 27.39C20.7423 29.6569 21.4184 31.8733 22.69 33.75C24.0521 35.7836 26.032 37.3253 28.3375 38.1475C30.6429 38.9696 33.1516 39.0286 35.4932 38.3157C37.8347 37.6028 39.8849 36.1559 41.3411 34.1885C42.7973 32.2211 43.5822 29.8376 43.58 27.39C43.58 24.76 42.9 22.8 41.58 21.56C40.4735 20.6151 39.0835 20.0661 37.63 20C38.1233 19.6739 38.5823 19.2987 39 18.88C39.9444 17.9256 40.6745 16.7808 41.1418 15.5221C41.6091 14.2633 41.8028 12.9195 41.71 11.58C41.6984 11.3866 41.617 11.2039 41.4809 11.066C41.3448 10.928 41.1632 10.8442 40.97 10.83C39.6301 10.7417 38.2866 10.9385 37.0283 11.4073C35.77 11.8762 34.6254 12.6064 33.67 13.55C32.7389 14.4827 32.0193 15.6047 31.56 16.84C31.1581 16.2698 30.6248 15.8048 30.0051 15.4845C29.3853 15.1642 28.6976 14.998 28 15C27.6171 15.0023 27.2366 15.0595 26.87 15.17C26.8337 14.0398 26.3597 12.9679 25.5481 12.1806C24.7365 11.3932 23.6507 10.952 22.52 10.95C21.7395 10.9499 20.9738 11.1631 20.3058 11.5668C19.6378 11.9704 19.0929 12.549 18.73 13.24C17.9379 12.4999 16.894 12.0888 15.81 12.09C14.6732 12.0922 13.582 12.5372 12.768 13.3307C11.954 14.1242 11.4812 15.2036 11.45 16.34C10.8309 16.2464 10.1989 16.2876 9.59723 16.4607C8.99554 16.6338 8.4383 16.9348 7.9636 17.3431C7.4889 17.7513 7.10792 18.2572 6.84669 18.8262C6.58546 19.3952 6.45014 20.0139 6.44997 20.64C6.44995 21.2488 6.5792 21.8506 6.82916 22.4057C7.07913 22.9608 7.44411 23.4565 7.89997 23.86C7.2425 24.4459 6.77885 25.218 6.57059 26.0738C6.36234 26.9295 6.41935 27.8283 6.73404 28.6508C7.04873 29.4734 7.60622 30.1807 8.33245 30.6789C9.05868 31.1771 9.91929 31.4425 10.8 31.44L10.79 31.41ZM40.1 12.41C40.0665 14.4125 39.2561 16.3237 37.8399 17.7399C36.4237 19.1561 34.5125 19.9665 32.51 20C32.5434 17.9974 33.3538 16.0863 34.77 14.6701C36.1862 13.2538 38.0974 12.4434 40.1 12.41ZM40.45 22.7C41.45 23.63 41.96 25.2 41.96 27.36C41.9645 29.5583 41.229 31.6942 39.872 33.4236C38.5149 35.1531 36.6153 36.3755 34.479 36.8939C32.3427 37.4124 30.0941 37.1968 28.0952 36.2819C26.0964 35.3669 24.4637 33.8058 23.46 31.85C22.9012 30.7563 22.5616 29.564 22.46 28.34C22.4055 28.0091 22.3721 27.6751 22.36 27.34C22.36 25.18 22.87 23.61 23.87 22.68C25.0539 21.7905 26.5249 21.3702 28 21.5C28.49 21.5 29 21.5 29.44 21.57L30.37 21.62H30.58L31.58 21.67C32.364 21.6899 33.1485 21.6666 33.93 21.6C36.11 21.45 38.85 21.23 40.45 22.71V22.7Z" fill="#3B3B3B"/>
                </svg>`;
              break;                                                            
            
            default:
              fallbackSrc = assetsUrl + 'img/no-image.jpg'; // General fallback image
          }
          // Get the parent container (product-card__image-container)
          const container = img.parentElement;
          
          if (fallbackSVG) {
            // Remove the broken image
            img.remove();

            // Insert the fallback SVG into the container
            container.innerHTML = fallbackSVG;  
          } else {
            img.src = fallbackSrc;
          }

        };
      });
    },
    destroyed: function destroyed() {
    },
    watch: {
      'pagination.totalPages': function (val) {
        this.updatePagination();
      },
      'pagination.currentPage': function (val) {
        this.scrollup();
        this.pagination.offset = (this.pagination.currentPage - 1) * this.pagination.elementsPerPage;
        this.performSearch();
      },
      searchResults: function(val, oldVal) {
        const resultCustomers = val.map((result) => {
          if (result.kiltaCustomer[0]) {
            return result.kiltaCustomer[0].id;
          } else {
            return '';
          }
        })
        let filteredCustomers = this.allCustomers.filter((customer) => {
          return resultCustomers.includes(customer.id.toString());
        })
        if (filteredCustomers.length > 0) {
          this.customers = filteredCustomers;
        };

        let newSearchFilters = this.searchFilters.filter((filter) => {
          return filter.groupTitle != 'Valmistaja'
        });

        if (_.isEmpty(val)) {
          filteredCustomers = this.allCustomers;

          this.pagination = _.get(getcategorySearchLandingData(), 'pagination');
        }

        newSearchFilters.push({
          'groupTitle': 'Valmistaja',
          'handle': 'kiltaCustomer',
          'id': 3,
          'categories': filteredCustomers,
          'multiple': true
        })
        if (resultCustomers.length > 0 && filteredCustomers.length > 0 && resultCustomers.length !== filteredCustomers.length) {
          // this.searchFilters = newSearchFilters;
        }
      },
      searchQuery: function(val, oldVal) {
        if(val !== oldVal) {
          this.isReady = false
        }
      },
      searchFilters: function(val, oldVal) {
        const newCustomers = val.find((item) => item.id === 3);
        const oldCustomers = oldVal.find((item) => item.id === 3);

        if (oldCustomers && (oldCustomers.categories.length !== newCustomers.categories.length)) {
          return;
        }
        let categoryIds = [];
        const self = this;
        const searchParam = getQueryParam('q');
        const categoryParam = getQueryParam('cat');
        const categoryIdParam = getQueryParam('cat-id');
        const pageParam = getQueryParam('page');

        if (!!searchParam) {
          self.searchQuery = searchParam;
        }
        if(!!categoryIdParam) {
          const categoryIds = categoryIdParam.map(id => parseInt(id));
          let newCategories = []
      
          _.each(categoryIds, categoryId => {
            _.each(self.searchFilters, filter => {
              let categoryObjects = _.map(_.filter(filter.categories, item => {
                return item.id == categoryId;
              }), item => {
                let itemObject = {}
                
                itemObject.title = _.get(item, 'title')
                itemObject.slug = _.get(item, 'slug')
                itemObject.id = _.get(item, 'id')
                itemObject.level = _.get(item, 'level')
                itemObject.groupTitle = filter.groupTitle
                itemObject.groupHandle = filter.handle
                if (item.children) {
                  itemObject.siblings = item.children
                }
  
                return itemObject;
              })

              _.each(filter.categories, category => {
                  categoryObjects = _.union(categoryObjects, _.map(_.filter(category.children, item => {
                    return item.id == categoryId;
                  }), item => {
                    let itemObject = {}
                
                    itemObject.title = _.get(item, 'title')
                    itemObject.slug = _.get(item, 'slug')
                    itemObject.id = _.get(item, 'id')
                    itemObject.level = _.get(item, 'level')
                    itemObject.parent = _.get(item, 'parent')
                    itemObject.groupTitle = filter.groupTitle
                    itemObject.groupHandle = filter.handle
                    if (category.children) {
                      itemObject.siblings = category.children
                    }
      
                    return itemObject;
                  }))
              })

              if (categoryObjects) {
                newCategories = _.union(newCategories, categoryObjects)
              }
            });
          })
          if (newCategories.length && JSON.stringify(self.searchCategories) !== JSON.stringify(newCategories)) {
            self.searchCategories = newCategories;
            const productCategory = _.find(self.searchCategories, category => category.groupTitle === 'Tuoteryhmä');
            if (productCategory) {
              if (productCategory.parent) {
                self.currentParentCat = productCategory.parent.slug;
              } else {
                self.currentParentCat = productCategory.slug;
              }
            } else {
              if (newCategories[0].groupTitle !== 'Valmistaja' && newCategories[0].groupTitle !== 'Ominaisuudet') {
                self.currentParentCat = newCategories[0].slug
              }
            }
          }
        }
        self.sectionType = searchSections;
      },
      currentParentCat: {
        handler: function(val, oldVal) {
        }
      },
      searchCategories: {
        handler: function(val, oldVal) {
        // if(!!oldVal && JSON.stringify(val) !== JSON.stringify(oldVal)) {
            // this.meta = _.get(getcategorySearchLandingData(), 'meta');
            if (!_.isEmpty(val)) {
              this.performSearch();
            } else {
              if (!_.isEmpty(this.searchQuery)) {
                this.performSearch();
              } else {
                this.searchResults = [];
                this.setHistory();
              }
            }
          // }
        },
        deep: true
      },
      searchSorting: function() {
        this.scrollup();
        this.performSearch();
      },
    },
    filters: {
      t: function(val) {
        const locale = document.getElementById('productSearchApp').dataset.locale || 'fi-FI';
        const trans = translation[locale];
        return trans[val] || val;
      },
    },
    computed: {
    },
    methods: {
      clearSearch() {
        this.searchResults = [];
        let pageUrl = location.protocol + '//' + location.host + location.pathname;
        history.replaceState(null, null, pageUrl);
        this.pagination = _.get(getcategorySearchLandingData(), 'pagination');
      },
      performSearch(init, showAll) {
        let self = this;

        if (init) {
          self.pagination = _.get(getcategorySearchLandingData(), 'pagination');
        }
        let searchTitle = !!self.searchQuery ? `${self.searchQuery}` : '';

        let searchCategoriesArray = [];
        if (!_.isEmpty(self.searchCategories)) {
          _.map(self.searchCategories, o => {
            searchCategoriesArray.push(o.id)
          })
        }

        let kiltaFoodTypes = [];
        let kiltaPropertyTypes = [];
        let kiltaCustomer = [];

        if (!_.isEmpty(self.searchCategories)) {
          self.searchCategories.forEach(category => {
            if (category.groupHandle === 'kiltaFoodTypes') {
              kiltaFoodTypes.push(category.id);
            }
            if (category.groupHandle === 'kiltaPropertyTypes') {
              kiltaPropertyTypes.push(category.id);
            }
            if (category.groupHandle === 'kiltaCustomers') {
              kiltaCustomer.push(category.id);
            }
          });
        }
                
        // Set the variables we will pass in to our query
        let variables = {
          sections: searchSections,
          needle: searchTitle ? `title:${searchTitle} OR kiltaMarketingName:${searchTitle}` : '',
          limit: self.pagination.elementsPerPage || 24,
          offset: self.pagination.offset || 0,
          orderBy: self.searchSorting,
          site: [searchSite],
          kiltaRetailProduct: searchSelectedSite === 'consumers' ? true : false
        };

        if (kiltaFoodTypes.length > 0) {
          variables.kiltaFoodTypes = ['or', ...kiltaFoodTypes];
        }

        if (kiltaPropertyTypes.length > 0) {
          variables.kiltaPropertyTypes = ['and', ...kiltaPropertyTypes];
        }

        if (kiltaCustomer.length > 0) {
          variables.kiltaCustomer = ['and', ...kiltaCustomer];
        }

        // Execute the query
        clearTimeout(filterChangeTimer);

        filterChangeTimer = setTimeout(function() {
          self.isLoading = true;
          if (searchCategoriesArray.length > 0) {
            self.setHistory();
          } else if (showAll) {
            if (window.history && window.history.pushState) {
              let pageUrl = location.protocol + '//' + location.host + location.pathname;
              let url = pageUrl + '?show-all=true';
              history.pushState(null, null, url);
            }
          }
          executeQuery(self.searchApi, searchQuery, variables, (data) => {
            const dataPath = data.data;
            self.searchResults = _.filter(dataPath.entries, entry => !!entry.id);
            self.pagination.totalCount = dataPath.entryCount;
            self.pagination.totalPages = Math.ceil(Number(dataPath.entryCount) / (self.pagination.elementsPerPage || 24));;
            if (!!data.data.meta) {
              self.allCategories = _.uniq(_.map(_.flatMap(data.data.meta.entries, 'newsCategory'), 'title'));
            }
            if(!self.isReady) {
              self.isReady = true;
            }
            self.isLoading = false;
          });
        }, 800);
      },
      setHistory: function() {
        let self = this;
        let paramString = '';
        if(!!self.searchQuery) {
          paramString += '?q=' + self.searchQuery;
        }
        if(!!_.get(self.searchCategories[0], 'slug')) {
          _.forEach(self.searchCategories, o => {
            paramString += !!paramString ? ('&cat=' + o.slug) : (paramString += '?cat=' + o.slug);
            paramString += !!paramString ? ('&cat-id=' + o.id) : (paramString += '?cat-id=' + o.id);
          })
        }
        if(!_.isEmpty(self.startDate)) {
          paramString += !!paramString ? ('&start=' + moment(self.startDate.start).format('YYYY-MM-DD')) : (paramString += '?start=' + moment(self.startDate.start).format('YYYY-MM-DD'));
          paramString += !!paramString ? ('&end=' + moment(self.startDate.end).format('YYYY-MM-DD')) : (paramString += '?end=' + moment(self.startDate.end).format('YYYY-MM-DD'));
        }
        if(!!self.pagination.currentPage && (!!self.searchQuery || !!_.get(self.searchCategories[0], 'slug'))) {
          paramString += !!paramString ? ('&page=' + self.pagination.currentPage) : (paramString += '?page=' + self.pagination.currentPage);
        }
        if (window.history && window.history.replaceState) {
          let pageUrl =
            location.protocol + '//' + location.host + location.pathname;
          let url = pageUrl + paramString;
          history.replaceState(null, null, url);
        }
      },
      scrollup: function() {
        var top = 0;

        setTimeout(function() {
          window.scrollTo(top, 0);
        }, 100);
        return false;
      },
      updatePagination() {
        const { pagination, currentPage, totalPages } = this;
        pagination.pages = [];
        for (let i = 0; i < totalPages; i++) {
          const index = i + 1;
          pagination.pages.push({
            text: index,
            url: this.getPageUrl(index),
            current: index === currentPage
          });
        }
        pagination.hasNext = currentPage < totalPages;
        pagination.hasPrev = currentPage > 1;
      },
      getCategories: function() {
        let self = this;
        const categoryQuery =
        `
        query searchQuery($site: [String])
          {
            kiltaFoodTypes: categories(group: "kiltaFoodTypes" level: 1 site: $site) {
              title
              slug
              id
              level
              parent {
                slug
              }
              children {
                title
                slug
                id
                level
                parent {
                  slug
                }
              }
            }
            kiltaPropertyTypes: categories(group: "kiltaPropertyTypes" level: 1 site: $site) {
              title
              slug
              id
              level
            }
          }
        `;
        executeQuery(axios.create(configureApi(apiUrl, searchApiToken)), categoryQuery, {
            limit: 100,
            site: [searchSite],
          }, (data) => {

          const kiltaPropertyTypes = data.data.kiltaPropertyTypes;
          self.propertyTypes = data.data.kiltaPropertyTypes;

          self.searchFilters = [
            {
              'groupTitle': 'Tuoteryhmä',
              'handle': 'kiltaFoodTypes',
              'id': 1,
              'categories': data.data.kiltaFoodTypes,
              'multiple': true
            },
            {
              'groupTitle': 'Ominaisuudet',
              'handle': 'kiltaPropertyTypes',
              'id': 2,
              'categories': kiltaPropertyTypes,
              'multiple': true
            },
            {
              'groupTitle': 'Valmistaja',
              'handle': 'kiltaCustomers',
              'id': 3,
              'categories': customers,
              'multiple': true
            },
          ];

          self.categoryCards = data.data.kiltaFoodTypes;
          if (!self.hasParams) {
            self.isLoading = false;
          }
        });
      }
    },
  });
};

!!document.getElementById('productSearchApp') && productSearchApp();
